module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"broker":"@:labels.broker"},"fr":{"broker":"@:labels.broker"}}')
  delete Component.options._Ctor
}
